module.exports = {"uploadRoute":"/upload","perspectiveRoute":"/perspective","sendEmailRoute":"/send"}


//////////////////
// WEBPACK FOOTER
// ./src/config/params.json
// module id = 120
// module chunks = 0